import {Divider, Box} from "@mui/material";

export default function MenuItem({ title, description, price }) {
    return (
        <Box sx={{ mb: 2, width: 1 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    fontSize: 22,
                }}
            >
                <div>{title}</div>
                <div>{price + "kr"}</div>
            </Box>
            <Divider />
            <p style={{ paddingLeft: 32, paddingRight: 16, fontSize: 14 }}>
                {description}
            </p>
        </Box>
    );
}
